<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Header from 'components/header/header'
import Footer from 'components/footer/footer'

export default {
  name: 'Home',
  computed: {
    props () {
      return this.$store.state.pages['home']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Header,
    Footer
  },
  methods: {
    ourPromise () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#our-promise') }, 500)
    },
    setsApart1 () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#what-sets-us-apart') }, 500)
    },
    aboutDoctor () {
      this.$router.push('/about-us')
      setTimeout(() => { this.$scrollTo('#ourdoctors') }, 500)
    },
    aboutDoctorTreatment () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#care1') }, 500)
    },
    aboutDoctorage7 () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#care0') }, 500)
    },
    aboutSmilegallery () {
      this.$router.push('/our-patient-is-you')
      setTimeout(() => { this.$scrollTo('#smile-gallery') }, 500)
    },
    aboutLocation0 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location0') }, 500)
    },
    aboutLocation1 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location1') }, 500)
    },
    aboutLocation2 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location2') }, 500)
    },
    aboutLocation3 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location3') }, 500)
    },
    aboutLocation4 () {
      this.$router.push('/contact')
      setTimeout(() => { this.$scrollTo('#location4') }, 500)
    }
  },
  data () {
    return {
      swiperOptionhome: {
        loop: true,
        spaceBetween: 15,
        slidesPerView: 4,
        slidesPerGroup: 1,
        speed: 1500,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?1d2e5d31